import { Category, DateRange, Filters } from '@emi/shared/models';
import { FilterTab } from './filter-tabs.model';
import { FilterType, FilterTypeState } from './filter-type.model';

export class TabModelBuilder {
    public static build(selectedFilters: Filters, isOverlay: boolean): FilterTab[] {
        const filterTabs = [];
        const noCategoriesSelected = selectedFilters.categories.length === 0;
        let selectedCategoriesCount: number = 0;

        const countSelectedCategories = (categories: Array<Category>): number => {
            for (const category of categories) {
                if (!category.childCategories || category.childCategories.length === 0) {
                    selectedCategoriesCount++;
                } else {
                    countSelectedCategories(category.childCategories);
                }
            }
            return selectedCategoriesCount;
        };
        filterTabs.push(new FilterTab(1, [new FilterType('Countries')], false, selectedFilters.countries.length));
        filterTabs.push(
            new FilterTab(
                2,
                [new FilterType('Categories')],
                isOverlay ? false : selectedFilters.countries.length === 0,
                countSelectedCategories(selectedFilters.categories)
            )
        );
        filterTabs.push(new FilterTab(3, [new FilterType('Suppliers')], isOverlay ? false : noCategoriesSelected, selectedFilters.suppliers.length));
        filterTabs.push(new FilterTab(4, [new FilterType('Brands')], isOverlay ? false : noCategoriesSelected, selectedFilters.brands.length));
        filterTabs.push(
            new FilterTab(5, [new FilterType('Attribute Types')], isOverlay ? false : noCategoriesSelected, selectedFilters.attributeTypes.length)
        );
        filterTabs.push(new FilterTab(6, [new FilterType('Attributes')], isOverlay ? false : noCategoriesSelected, selectedFilters.attributes.length));
        filterTabs.push(
            new FilterTab(7, [new FilterType('Retailer Types')], isOverlay ? false : noCategoriesSelected, selectedFilters.retailerTypes.length)
        );
        filterTabs.push(new FilterTab(8, [new FilterType('Retailers')], isOverlay ? false : noCategoriesSelected, selectedFilters.retailers.length));

        // TODO: Re-enable when we want promotions filter released
        // filterTabs.push(new FilterTab(10, [new FilterType('Promotions')], isOverlay ? false : noCategoriesSelected, selectedFilters.promotions.length));

        filterTabs.push(
            new FilterTab(
                9,
                [
                    new FilterType('Date Range', this.getDateRangeFilterTypeState(selectedFilters)),
                    new FilterType('Price'),
                    new FilterType('Total SKU Size')
                ],
                isOverlay ? false : noCategoriesSelected,
                0
            )
        );

        return filterTabs;
    }

    private static getDateRangeFilterTypeState(selectedFilters: Filters): FilterTypeState | undefined {
        const endDate = selectedFilters.defaultDateRange?.endDate;
        if (!endDate) return undefined;

        const defaultDateRange = DateRange.getDefaultDateRange(endDate!);

        if (selectedFilters.dateRange && DateRange.isEqualDateRange(selectedFilters.dateRange, defaultDateRange)) {
            return 'Default';
        } else if (selectedFilters.dateRange?.startDate && selectedFilters.dateRange?.endDate) {
            return 'Custom';
        }
        return undefined;
    }
}
